import styled from 'styled-components'

export default styled.div`
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 15px 35px rgba(50, 50, 50, 0.1);
  border-radius: 10px;
  padding: 2em;
`
